import React from "react";
import {
  ADMIN_CHARGE_OPTIONS,
  isValidAdminCharge,
} from "../../constants/adminCharge";

const AdminChargeSelect = ({
  value,
  onChange,
  error = false,
  className = "",
  placeholder = "Select admin charge",
  required = true,
  disabled = false,
  allowEmpty = false,
}) => {
  const numericValue =
    value === "" || value === null || value === undefined
      ? ""
      : String(Number(value));
  const hasLegacyValue =
    numericValue !== "" && !isValidAdminCharge(numericValue);

  const baseClass =
    "placeholder:text-sm text-sm font-medium text-gray-800 w-full px-3 pr-8 py-1 border rounded-lg focus:outline-none focus:border-primary focus:ring-none disabled:bg-gray-100 disabled:text-gray-500 disabled:cursor-not-allowed";
  const errorClass = error ? "border-red-500" : "border-gray-300";

  return (
    <select
      value={numericValue}
      onChange={(e) => {
        const next = e.target.value;
        if (next === "") {
          onChange(allowEmpty ? "" : ADMIN_CHARGE_OPTIONS[0]);
          return;
        }
        onChange(Number(next));
      }}
      disabled={disabled}
      required={required}
      className={`${baseClass} ${errorClass} ${className}`.trim()}
    >
      {allowEmpty && <option value="">{placeholder}</option>}
      {!allowEmpty && numericValue === "" && (
        <option value="" disabled>
          {placeholder}
        </option>
      )}
      {ADMIN_CHARGE_OPTIONS.map((option) => (
        <option key={option} value={option}>
          {option}%
        </option>
      ))}
      {hasLegacyValue && (
        <option value={numericValue}>{numericValue}% (current)</option>
      )}
    </select>
  );
};

export default AdminChargeSelect;
